(function () {
  'use strict';
  /* Document-level listeners must only ever be bound once, even if this file is evaluated again. */
  if (window.__wonderfulBooksTheme) return;
  window.__wonderfulBooksTheme = true;

  var T = window.theme || {};
  T.routes = T.routes || {};
  T.strings = T.strings || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var html = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Live-region announcements ---------- */
  function announce(message) {
    var el = $('[data-announcer]');
    if (!el || !message) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = message; }, 50);
  }

  /* ---------- Money: use the store's own money format / active currency ---------- */
  function withDelimiters(cents, precision, thousands, decimal) {
    var n = Number(cents);
    if (isNaN(n)) return '0';
    var fixed = (n / 100).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var fmt = T.moneyWithCurrencyFormat || T.moneyFormat;
    var sameCurrency = !T.currency || !T.shopCurrency || T.currency === T.shopCurrency;
    if (fmt && sameCurrency) {
      var token = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      if (token) {
        var value;
        switch (token[1]) {
          case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
          case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
          case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
          case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
          case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
          case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
          case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
          case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
        }
        if (value !== undefined) return fmt.replace(/<[^>]*>/g, '').replace(/\{\{\s*\w+\s*\}\}/, function () { return value; });
      }
    }
    try {
      return new Intl.NumberFormat(T.locale || html.lang || undefined, { style: 'currency', currencyDisplay: 'code', currency: T.currency || T.shopCurrency || 'USD' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + (T.currency ? ' ' + T.currency : '');
    }
  }

  /* ---------- Cart requests: always check response.ok and Shopify error bodies ---------- */
  function cartError(message) {
    var err = new Error(message || T.strings.errorGeneric || 'Request failed');
    err.userMessage = message || T.strings.errorGeneric;
    return err;
  }
  function describeCartError(status, data) {
    if (data && typeof data.description === 'string' && data.description) return data.description;
    if (data && typeof data.message === 'string' && data.message && data.message !== 'Cart Error') return data.message;
    if (status === 404) return T.strings.errorUnavailable;
    if (status === 429) return T.strings.errorRate;
    return T.strings.errorGeneric;
  }
  function cartRequest(url, opts) {
    opts = opts || {};
    var headers = { Accept: 'application/json' };
    Object.keys(opts.headers || {}).forEach(function (k) { headers[k] = opts.headers[k]; });
    return fetch(url, { method: opts.method || 'GET', headers: headers, body: opts.body, credentials: 'same-origin' })
      .then(function (res) {
        return res.text().then(function (text) {
          var data = null;
          try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
          var bodyIsError = data && !Array.isArray(data) && data.message && data.description && data.status;
          if (!res.ok || bodyIsError) throw cartError(describeCartError(res.status, data));
          if (data === null) throw cartError(T.strings.errorGeneric);
          return data;
        });
      }, function () { throw cartError(T.strings.errorNetwork); });
  }

  /* ---------- Modal stack: focus trap, inert background, Escape, focus restore ---------- */
  var modalStack = [];
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
  function focusables(container) {
    return $$(FOCUSABLE, container).filter(function (el) {
      var closed = el.closest('details:not([open])');
      var insideClosedContent = closed && !$('summary', closed).contains(el);
      return !insideClosedContent && !el.hidden && !el.closest('[hidden],[inert]') && (el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    });
  }
  function setBackgroundInert(keepEl, inert) {
    Array.prototype.slice.call(document.body.children).forEach(function (child) {
      if (/^(SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(child.tagName)) return;
      if (child === keepEl || child.contains(keepEl)) return;
      if (inert) {
        if (child.__wbPrevInert === undefined) child.__wbPrevInert = !!child.inert;
        child.inert = true;
      } else if (child.__wbPrevInert !== undefined) {
        child.inert = child.__wbPrevInert;
        child.__wbPrevInert = undefined;
      }
    });
  }
  function pushModal(entry, opener) {
    entry.opener = opener || document.activeElement;
    modalStack.push(entry);
    html.classList.add('drawer-open');
    setBackgroundInert(entry.container, true);
  }
  function popModal(entry, fallbackFocus) {
    var i = modalStack.indexOf(entry);
    if (i === -1) return;
    modalStack.splice(i, 1);
    if (!modalStack.length) html.classList.remove('drawer-open');
    setBackgroundInert(entry.container, false);
    var visible = function (el) { return el && el !== document.body && !entry.container.contains(el) && document.contains(el) && el.getClientRects().length > 0 && !el.disabled; };
    var target = visible(entry.opener) ? entry.opener : null;
    target = target || (visible(fallbackFocus) ? fallbackFocus : null);
    if (target && target.focus) target.focus();
  }
  document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented) return;
    var top = modalStack[modalStack.length - 1];
    if (!top) return;
    if (e.key === 'Escape') { e.preventDefault(); top.close(); return; }
    if (e.key !== 'Tab') return;
    var items = focusables(top.panel);
    if (!items.length) { e.preventDefault(); top.panel.focus(); return; }
    var first = items[0], last = items[items.length - 1], active = document.activeElement;
    if (!top.panel.contains(active)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && (active === first || active === top.panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Drawers (cart + search) ---------- */
  function drawerOf(el) { return el && el.__wbModal; }
  function openDrawer(el, focusSel, opener) {
    if (!el) return;
    var existing = drawerOf(el);
    if (existing && !el.hidden) return;
    modalStack.slice().forEach(function (m) { m.close(); });
    var panel = $('[role="dialog"]', el);
    if (!panel) return;
    var entry = { container: el, panel: panel, close: function () { closeDrawer(el); } };
    el.__wbModal = entry;
    el.hidden = false;
    pushModal(entry, opener);
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      var f = focusSel ? $(focusSel, el) : null;
      (f || panel).focus();
    });
  }
  function closeDrawer(el) {
    var entry = drawerOf(el);
    if (!el || !entry || el.hidden) return;
    el.__wbModal = null;
    if (el.__wbSuppress) el.__wbSuppress();
    el.classList.remove('is-open');
    popModal(entry, $(el.id === 'LeadPopup' ? '.header__logo' : el.id === 'SearchModal' ? '[data-search-open]' : '[data-cart-open]'));
    setTimeout(function () { if (!el.__wbModal) el.hidden = true; }, reduceMotion.matches ? 0 : 200);
  }

  /* ---------- Mobile navigation ---------- */
  var mobileNavQuery = window.matchMedia('(max-width: 989px)');
  var navEntry = null;
  function closeNavDropdowns(except) {
    $$('[data-nav-dropdown]').forEach(function (item) {
      if (item !== except) { item.open = false; $('summary', item).setAttribute('aria-expanded', 'false'); }
    });
  }
  function initNavDropdowns(root) {
    $$('[data-nav-dropdown]', root).forEach(function (item) {
      if (item.__wbInit) return;
      item.__wbInit = true;
      var summary = $('summary', item);
      item.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', String(item.open));
        if (item.open) closeNavDropdowns(item);
      });
      item.parentNode.addEventListener('pointerenter', function (e) {
        if (!mobileNavQuery.matches && e.pointerType === 'mouse') { closeNavDropdowns(item); item.open = true; }
      });
      item.parentNode.addEventListener('pointerleave', function () {
        if (!mobileNavQuery.matches && !item.parentNode.contains(document.activeElement)) { item.open = false; summary.setAttribute('aria-expanded', 'false'); }
      });
      item.parentNode.addEventListener('focusout', function () {
        setTimeout(function () { if (!item.parentNode.contains(document.activeElement)) { item.open = false; summary.setAttribute('aria-expanded', 'false'); } }, 0);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && item.open) { e.preventDefault(); item.open = false; summary.setAttribute('aria-expanded', 'false'); summary.focus(); }
      });
    });
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('#MainNav')) closeNavDropdowns(); });
  function setNav(open) {
    var nav = document.getElementById('MainNav');
    var toggle = $('[data-nav-toggle]');
    if (!nav || !toggle) return;
    var isOpen = nav.classList.contains('is-open');
    if (isOpen === open) return;
    if (open && !mobileNavQuery.matches) return;
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open);
    if (open) {
      navEntry = { container: nav, panel: nav, close: function () { setNav(false); } };
      pushModal(navEntry);
      var c = $('[data-nav-close]', nav);
      (c || nav).focus();
    } else if (navEntry) {
      closeNavDropdowns();
      var entry = navEntry;
      navEntry = null;
      entry.opener = toggle;
      popModal(entry, mobileNavQuery.matches ? toggle : $('.header__logo'));
    }
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) { var nav = document.getElementById('MainNav'); setNav(!(nav && nav.classList.contains('is-open'))); return; }
    if (e.target.closest('[data-nav-close]')) setNav(false);
  });
  mobileNavQuery.addEventListener('change', function (e) { closeNavDropdowns(); if (!e.matches) setNav(false); });

  /* ---------- Delegated page controls (bound once) ---------- */
  document.addEventListener('click', function (e) {
    var plain = !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button);

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = $('[data-qty-input]', step.parentNode);
      if (input) {
        var min = parseInt(input.min, 10) || 1;
        var current = parseInt(input.value, 10);
        input.value = Math.max(min, (isNaN(current) ? min : current) + Number(step.dataset.qtyStep));
        input.removeAttribute('aria-invalid');
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      return;
    }

    var cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && plain && $('#CartDrawer') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openDrawer($('#CartDrawer'));
      syncCartFromServer({ quiet: true });
      return;
    }
    var searchOpen = e.target.closest('[data-search-open]');
    if (searchOpen && plain && $('#SearchModal')) {
      e.preventDefault();
      openDrawer($('#SearchModal'), '[data-search-input]');
      return;
    }
    var close = e.target.closest('[data-drawer-close],[data-search-close]');
    if (close) {
      var drawer = close.closest('.drawer');
      if (drawer) closeDrawer(drawer);
      return;
    }
    var line = e.target.closest('#CartDrawer [data-line][data-qty]');
    if (line) { changeCartLine(line); return; }

    var tabLink = e.target.closest('[data-tab-link]');
    if (tabLink) {
      var tab = document.getElementById(tabLink.getAttribute('data-tab-link'));
      if (!tab) return;
      e.preventDefault();
      tab.click();
      var tabsRoot = tab.closest('[data-tabs]');
      if (tabsRoot && tabsRoot.scrollIntoView) tabsRoot.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      tab.focus();
    }
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) $$('[data-product-form]').forEach(function (f) { if (f.__wbState) { f.__wbState.busy = false; f.__wbSync(); } });
  });

  /* ---------- Cart drawer state ---------- */
  function setCount(n) {
    n = Number(n);
    if (isNaN(n)) return;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
      var link = el.closest('a');
      if (link) link.setAttribute('aria-label', T.strings.cartLabel + ' (' + n + ')');
    });
  }
  function showCartError(message) {
    var box = $('[data-cart-error]');
    if (!box) return;
    box.textContent = message || T.strings.errorGeneric;
    box.hidden = false;
  }
  function clearCartError() {
    var box = $('[data-cart-error]');
    if (box) { box.textContent = ''; box.hidden = true; }
  }
  function applyDrawerHtml(markup) {
    var drawer = $('#CartDrawer');
    if (!markup || !drawer) return false;
    var doc = new DOMParser().parseFromString(markup, 'text/html');
    var fresh = doc.querySelector('[data-cart-drawer-inner]');
    var cur = $('[data-cart-drawer-inner]', drawer);
    if (!fresh || !cur) return false;
    cur.innerHTML = fresh.innerHTML;
    var c = $('[data-cart-count-inner]', cur);
    if (c) setCount(c.textContent);
    return true;
  }
  /* One source of truth: re-render the drawer section from the server. */
  function syncCartFromServer(opts) {
    opts = opts || {};
    return cartRequest((T.routes.root || '/') + '?sections=cart-drawer')
      .then(function (data) { applyDrawerHtml(data['cart-drawer']); })
      .catch(function (err) { if (!opts.quiet) showCartError(err.userMessage); });
  }
  function setDrawerBusy(busy) {
    var inner = $('#CartDrawer [data-cart-drawer-inner]');
    if (!inner) return;
    inner.setAttribute('aria-busy', busy ? 'true' : 'false');
    $$('[data-line]', inner).forEach(function (b) { b.setAttribute('aria-disabled', busy ? 'true' : 'false'); });
  }
  var drawerBusy = false;
  function changeCartLine(btn) {
    if (drawerBusy) return;
    var lineNo = Number(btn.dataset.line), qty = Number(btn.dataset.qty);
    if (!(lineNo > 0) || !(qty >= 0) || Math.floor(qty) !== qty) { showCartError(T.strings.errorQuantity); return; }
    var act = btn.dataset.act, removing = qty === 0;
    drawerBusy = true;
    clearCartError();
    setDrawerBusy(true);
    cartRequest((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineNo, quantity: qty, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (cart) {
        var applied = cart.sections && applyDrawerHtml(cart.sections['cart-drawer']);
        if (!applied) return syncCartFromServer();
        if (typeof cart.item_count === 'number') setCount(cart.item_count);
      })
      .then(function () {
        announce(removing ? T.strings.removed : T.strings.updated);
        var again = act && $('#CartDrawer [data-line="' + lineNo + '"][data-act="' + act + '"]');
        (again || $('#CartDrawer .drawer__panel')).focus();
      })
      .catch(function (err) {
        var message = err.userMessage || T.strings.errorGeneric;
        showCartError(message);
        announce(message);
        return syncCartFromServer({ quiet: true }).then(function () {
          var again = act && $('#CartDrawer [data-line="' + lineNo + '"][data-act="' + act + '"]');
          (again || $('#CartDrawer .drawer__panel')).focus();
        });
      })
      .then(function () { drawerBusy = false; setDrawerBusy(false); });
  }

  /* ---------- Product form: variants, validation, AJAX add to cart ---------- */
  function initProductForm(root) {
    $$('[data-product-form]', root).forEach(function (form) {
      if (form.__wbState) return;
      var scope = form.closest('.shopify-section') || document;
      var dataEl = $('[data-product-json]', scope);
      if (!dataEl) return;
      var product;
      try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var variantsById = {};
      product.variants.forEach(function (v) { variantsById[v.id] = v; });

      var state = { busy: false, variant: null };
      form.__wbState = state;
      /* With JavaScript the theme shows its own accessible, announced error messages instead of the browser's tooltip. */
      form.noValidate = true;
      var addBtn = $('[data-add-to-cart]', form);
      var buyBtn = $('[data-buy-now]', form);
      var qtyWrap = $('[data-qty-wrap]', form);
      var qtyInput = $('[data-qty-input]', form);
      var errorBox = $('[data-form-error]', form);
      var priceEl = $('[data-product-price]', scope);
      var buyNowClicked = false;

      function selectedVariantId() {
        var control = $('input[name="id"]:checked', form) || $('select[name="id"]', form) || $('input[name="id"]', form);
        return control ? Number(control.value) : NaN;
      }
      function showError(message, field) {
        if (errorBox) { errorBox.textContent = message; errorBox.hidden = false; }
        if (field) field.setAttribute('aria-invalid', 'true');
        announce(message);
      }
      function clearError() {
        if (errorBox) { errorBox.textContent = ''; errorBox.hidden = true; }
        if (qtyInput) qtyInput.removeAttribute('aria-invalid');
      }
      function sync() {
        var ok = !!state.variant && state.variant.available;
        [addBtn, buyBtn].forEach(function (b) {
          if (!b) return;
          b.disabled = !ok;
          b.setAttribute('aria-disabled', state.busy ? 'true' : 'false');
          b.setAttribute('aria-busy', state.busy ? 'true' : 'false');
        });
        if (addBtn) {
          var label = !ok ? addBtn.dataset.soldLabel : (state.busy && !buyNowClicked ? addBtn.dataset.addingLabel : addBtn.dataset.addLabel);
          if (label && addBtn.textContent.trim() !== label) addBtn.textContent = label;
        }
      }
      form.__wbSync = sync;
      function renderPrice(variant) {
        if (!priceEl) return;
        var wrap = document.createElement('div');
        wrap.className = 'price';
        if (!variant.available) {
          var na = document.createElement('span');
          na.className = 'price__unavailable';
          na.textContent = (addBtn && addBtn.dataset.soldLabel) || '';
          wrap.appendChild(na);
        } else if (variant.compare_at_price > variant.price) {
          var sale = document.createElement('span');
          sale.className = 'price__sale';
          sale.textContent = formatMoney(variant.price);
          var was = document.createElement('s');
          was.className = 'price__compare';
          was.textContent = formatMoney(variant.compare_at_price);
          wrap.appendChild(sale); wrap.appendChild(was);
        } else {
          var plain = document.createElement('span');
          plain.textContent = formatMoney(variant.price);
          wrap.appendChild(plain);
        }
        priceEl.innerHTML = '';
        priceEl.appendChild(wrap);
      }
      function updateVariant(fromUser) {
        var variant = variantsById[selectedVariantId()] || null;
        state.variant = variant;
        var picked = $('input[name="id"]:checked', form);
        var formatType = picked ? picked.dataset.formatType : '';
        if (qtyWrap) {
          var digital = formatType === 'digital';
          qtyWrap.hidden = digital;
          if (digital && qtyInput) qtyInput.value = 1;
        }
        $$('[data-format-note]').forEach(function (n) { n.hidden = !formatType || n.dataset.formatNote !== formatType; });
        if (variant) {
          renderPrice(variant);
          if (fromUser && window.history && history.replaceState) {
            try { var url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url); } catch (e) { /* ignore */ }
          }
        }
        clearError();
        sync();
      }
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[name="id"], select[name="id"]')) updateVariant(true);
      });
      if (qtyInput) qtyInput.addEventListener('input', clearError);
      [addBtn, buyBtn].forEach(function (b) { if (b) b.addEventListener('click', function () { buyNowClicked = b === buyBtn; }); });

      function readQuantity() {
        if (!qtyInput || (qtyWrap && qtyWrap.hidden)) return 1;
        var raw = String(qtyInput.value).trim();
        var n = Number(raw);
        if (!/^\d+$/.test(raw) || !(n >= 1)) return null;
        return n;
      }
      form.addEventListener('submit', function (e) {
        var buyNow = buyNowClicked || !!(e.submitter && e.submitter.hasAttribute && e.submitter.hasAttribute('data-buy-now'));
        buyNowClicked = false;
        e.preventDefault();
        if (state.busy) return;
        clearError();
        if (!state.variant) { showError(T.strings.errorUnavailable); return; }
        if (!state.variant.available) { showError(T.strings.errorUnavailable); return; }
        var qty = readQuantity();
        if (qty === null) { showError(T.strings.errorQuantity, qtyInput); if (qtyInput) qtyInput.focus(); return; }
        state.busy = true;
        buyNowClicked = buyNow;
        sync();
        var fd = new FormData(form);
        fd.set('quantity', qty);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', window.location.pathname);
        cartRequest((T.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', body: fd })
          .then(function (res) {
            if (buyNow) { window.location.assign('/checkout'); return 'redirect'; }
            var applied = res.sections && applyDrawerHtml(res.sections['cart-drawer']);
            return applied ? null : syncCartFromServer();
          })
          .then(function (outcome) {
            if (outcome === 'redirect') return;
            clearCartError();
            announce(T.strings.added);
            state.busy = false; buyNowClicked = false; sync();
            openDrawer($('#CartDrawer'), null, addBtn);
          })
          .catch(function (err) {
            showError(err.userMessage || T.strings.errorGeneric);
            state.busy = false; buyNowClicked = false; sync();
          });
      });
      updateVariant(false);
    });
  }

  /* ---------- Search modal + predictive search (layout-level, bound once) ---------- */
  (function initPredictiveSearch() {
    var timer, controller;
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-search-input]');
      if (!input) return;
      var modal = input.closest('#SearchModal');
      var results = modal && $('[data-search-results]', modal);
      if (!results) return;
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; results.setAttribute('aria-busy', 'false'); return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        results.setAttribute('aria-busy', 'true');
        var url = T.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,article,page&resources[limit]=4&section_id=predictive-search';
        fetch(url, { signal: controller.signal, credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.text(); })
          .then(function (markup) {
            var doc = new DOMParser().parseFromString(markup, 'text/html');
            var sec = doc.querySelector('.shopify-section') || doc.body;
            results.innerHTML = sec.innerHTML;
            results.setAttribute('aria-busy', 'false');
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            results.innerHTML = '';
            var p = document.createElement('p');
            p.className = 'muted';
            p.textContent = T.strings.searchError || '';
            results.appendChild(p);
            results.setAttribute('aria-busy', 'false');
          });
      }, 250);
    });
  })();

  /* ---------- Section initialisers (run on load and on every theme-editor section reload) ---------- */
  function initSortControls(root) {
    $$('[data-sort]', root).forEach(function (sort) {
      if (sort.__wbInit) return;
      sort.__wbInit = true;
      sort.addEventListener('change', function () { sort.form.submit(); });
    });
  }

  var countIo = null;
  function initCountUp(root) {
    var counters = $$('[data-countup]', root).filter(function (el) { return !el.__wbInit; });
    if (!counters.length || !('IntersectionObserver' in window) || reduceMotion.matches) return;
    var parseCount = function (txt) {
      var m = txt.trim().match(/^([^\d-]*)(\d[\d,.]*)(.*)$/);
      if (!m) return null;
      var num = parseFloat(m[2].replace(/,/g, ''));
      if (isNaN(num)) return null;
      return { pre: m[1], suf: m[3], num: num, dec: (m[2].split('.')[1] || '').length, commas: m[2].indexOf(',') > -1 };
    };
    var fmtCount = function (n, p) {
      var s = n.toFixed(p.dec);
      if (p.commas) { var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); s = parts.join('.'); }
      return p.pre + s + p.suf;
    };
    countIo = countIo || new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countIo.unobserve(entry.target);
        var el = entry.target, p = parseCount(el.textContent), start = null;
        if (!p) return;
        el.textContent = fmtCount(0, p);
        requestAnimationFrame(function step(ts) {
          if (start === null) start = ts;
          var t = Math.min((ts - start) / 1600, 1);
          el.textContent = fmtCount(p.num * (1 - Math.pow(1 - t, 3)), p);
          if (t < 1) requestAnimationFrame(step); else el.textContent = fmtCount(p.num, p);
        });
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { el.__wbInit = true; countIo.observe(el); });
  }

  function initCountdowns(root) {
    $$('[data-lead-popup]', root).forEach(function (el) { clearTimeout(el.__wbTimer); });
    $$('[data-countdown]', root).forEach(function (el) {
      if (el.__wbInit) return;
      var end = parseInt(el.getAttribute('data-countdown'), 10) * 1000;
      if (isNaN(end)) return;
      el.__wbInit = true;
      var cells = { days: $('[data-cd="days"]', el), hours: $('[data-cd="hours"]', el), minutes: $('[data-cd="minutes"]', el), seconds: $('[data-cd="seconds"]', el) };
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      function tick() {
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        cells.days.textContent = Math.floor(s / 86400);
        cells.hours.textContent = pad(Math.floor(s % 86400 / 3600));
        cells.minutes.textContent = pad(Math.floor(s % 3600 / 60));
        cells.seconds.textContent = pad(s % 60);
        if (s === 0) clearInterval(el.__wbTimer);
      }
      el.__wbTimer = setInterval(tick, 1000);
      tick();
    });
  }

  function initCarousels(root) {
    $$('[data-carousel]', root).forEach(function (wrapper) {
      if (wrapper.__wbInit) return;
      var carousel = wrapper.querySelector('.carousel');
      if (!carousel || !carousel.children.length) return;
      wrapper.__wbInit = true;
      Array.prototype.slice.call(carousel.children).forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        $$(FOCUSABLE, clone).forEach(function (f) { f.setAttribute('tabindex', '-1'); });
        carousel.appendChild(clone);
      });
      var paused = false, pos = 0, frame = null;
      wrapper.addEventListener('mouseenter', function () { paused = true; });
      wrapper.addEventListener('mouseleave', function () { paused = false; });
      wrapper.addEventListener('focusin', function () { paused = true; });
      wrapper.addEventListener('focusout', function () { paused = false; });
      function loop() {
        if (!paused && !reduceMotion.matches && !document.hidden) {
          pos += 40 / 16.67;
          carousel.scrollLeft = pos % (carousel.scrollWidth / 2);
        }
        frame = requestAnimationFrame(loop);
      }
      frame = requestAnimationFrame(loop);
      wrapper.__wbStop = function () { cancelAnimationFrame(frame); };
    });
  }

  function initReviewMarquee(root) {
    $$('.review-marquee', root).forEach(function (section) {
      var toggle = $('[data-review-marquee-toggle]', section);
      if (!toggle || toggle.__wbInit) return;
      toggle.__wbInit = true;
      var pauseLabel = $('[data-label-pause]', toggle);
      var playLabel = $('[data-label-play]', toggle);
      toggle.addEventListener('click', function () {
        var paused = section.classList.toggle('is-paused');
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (pauseLabel) pauseLabel.hidden = paused;
        if (playLabel) playLabel.hidden = !paused;
      });
    });
  }

  function initFaq(root) {
    $$('.faq__item', root).forEach(function (item) {
      if (item.__wbInit) return;
      var summary = $('summary', item);
      var answer = $('.faq__answer', item);
      if (!summary || !answer || typeof item.animate !== 'function') return;
      item.__wbInit = true;
      var anim = null;
      function finish(open) {
        item.open = open;
        item.classList.remove('is-closing');
        item.style.height = item.style.overflow = '';
        anim = null;
      }
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (reduceMotion.matches) { item.open = !item.open; return; }
        var opening = !item.open || item.classList.contains('is-closing');
        var start = item.getBoundingClientRect().height;
        if (anim) anim.cancel();
        item.style.overflow = 'hidden';
        var end;
        if (opening) {
          item.classList.remove('is-closing');
          item.style.height = '';
          item.open = true;
          end = item.scrollHeight;
        } else {
          item.classList.add('is-closing');
          item.style.height = '';
          item.open = false;
          end = item.getBoundingClientRect().height;
          item.open = true;
        }
        item.style.height = start + 'px';
        anim = item.animate({ height: [start + 'px', end + 'px'] }, { duration: 400, easing: 'cubic-bezier(.22,.61,.36,1)' });
        answer.animate({ opacity: opening ? [0, 1] : [1, 0], transform: opening ? ['translateY(-6px)', 'none'] : ['none', 'translateY(-6px)'] }, { duration: 300, easing: 'ease' });
        anim.onfinish = function () { finish(opening); };
        anim.oncancel = function () { anim = null; };
      });
    });
  }

  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (tabsRoot) {
      if (tabsRoot.__wbInit) return;
      var tabs = $$('[role="tab"]', tabsRoot);
      var panels = $$('[role="tabpanel"]', tabsRoot);
      if (!tabs.length) return;
      tabsRoot.__wbInit = true;
      function activate(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          t.classList.toggle('is-active', on);
        });
        var target = tab.getAttribute('aria-controls');
        panels.forEach(function (p) {
          var show = p.id === target;
          p.hidden = !show;
          p.classList.toggle('is-active', show);
        });
        if (focus) tab.focus();
      }
      /* Progressive enhancement: without JS every panel is visible and the tab bar is hidden. */
      tabsRoot.classList.add('is-enhanced');
      var initial = $('[role="tab"].is-active', tabsRoot) || tabs[0];
      var auto = $('[data-activate-tab]', tabsRoot);
      var autoTab = auto && document.getElementById(auto.getAttribute('data-activate-tab'));
      activate(autoTab || initial, false);
      tabsRoot.addEventListener('click', function (e) {
        var tab = e.target.closest('[role="tab"]');
        if (tab) activate(tab);
      });
      tabsRoot.addEventListener('keydown', function (e) {
        var cur = e.target.closest('[role="tab"]');
        if (!cur) return;
        var i = tabs.indexOf(cur), n = tabs.length;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); activate(tabs[(i + 1) % n], true); }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); activate(tabs[(i - 1 + n) % n], true); }
        else if (e.key === 'Home') { e.preventDefault(); activate(tabs[0], true); }
        else if (e.key === 'End') { e.preventDefault(); activate(tabs[n - 1], true); }
      });
    });
  }

  /* Home email popup: opens once after a delay, then stays quiet for N days (closed or subscribed). */
  function initLeadPopup(root) {
    $$('[data-lead-popup]', root).forEach(function (el) {
      if (el.__wbInit) return;
      el.__wbInit = true;
      var KEY = 'wb-lead-popup';
      var days = Number(el.getAttribute('data-days')) || 14;
      var delay = (Number(el.getAttribute('data-delay')) || 4) * 1000;
      function suppressedNow() { try { var t = Number(localStorage.getItem(KEY)); return !!t && Date.now() < t; } catch (e) { return false; } }
      function suppress() { try { localStorage.setItem(KEY, String(Date.now() + days * 86400000)); } catch (e) {} }
      el.__wbSuppress = suppress;
      var wasOpen = false;
      new MutationObserver(function () {
        if (!el.hidden) wasOpen = true;
        else if (wasOpen) { wasOpen = false; suppress(); }
      }).observe(el, { attributes: true, attributeFilter: ['hidden'] });
      /* Back from submitting the popup form (success or error): reopen it so the result is visible. */
      var form = $('#lead-popup-form', el);
      var returned = !!form && location.hash === '#lead-popup-form';
      /* Someone just subscribed through another form on this page: do not interrupt them. */
      if (/[?&]customer_posted=true/.test(location.search) && !returned) { suppress(); return; }
      if ($('[data-lead-posted]', el)) suppress();
      if (returned) { openDrawer(el); return; }
      if (window.Shopify && window.Shopify.designMode) return;
      if (suppressedNow()) return;
      function tryOpen() {
        if (!document.contains(el) || suppressedNow()) return;
        var active = document.activeElement;
        var typing = active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
        if (modalStack.length || typing || document.hidden) { el.__wbTimer = setTimeout(tryOpen, 15000); return; }
        openDrawer(el);
      }
      el.__wbTimer = setTimeout(tryOpen, delay);
    });
  }

  function initSection(root) {
    root = root || document;
    initNavDropdowns(root);
    initProductForm(root);
    initSortControls(root);
    initLeadPopup(root);
    initCountUp(root);
    initCountdowns(root);
    initCarousels(root);
    initReviewMarquee(root);
    initFaq(root);
    initTabs(root);
  }
  function cleanupSection(root) {
    $$('[data-lead-popup]', root).forEach(function (el) { clearTimeout(el.__wbTimer); });
    $$('[data-countdown]', root).forEach(function (el) { clearInterval(el.__wbTimer); });
    $$('[data-carousel]', root).forEach(function (el) { if (el.__wbStop) el.__wbStop(); });
    /* A modal whose markup is being replaced must release the page (inert, scroll lock). */
    modalStack.slice().forEach(function (m) { if (root.contains(m.container) || root === m.container) { m.container.__wbModal = null; popModal(m); } });
  }

  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { cleanupSection(e.target); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initSection(document); });
  else initSection(document);
})();
